import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { X, Check } from 'lucide-react';
export function PainPoints() {
  const before = ['Conocías solo algunos faraones famosos.', 'Pensabas que las pirámides eran el único gran misterio.', 'Confundías mitos con hechos históricos.', 'Nunca entendías cómo vivían realmente los egipcios.', 'Veías documentales con información incompleta.'];
  const after = ['Comprendés el origen de la civilización egipcia.', 'Descubrís la historia detrás de los grandes faraones.', 'Conocés el verdadero significado de sus dioses y rituales.', 'Explorás su vida cotidiana, cultura y costumbres.', 'Descubrís misterios respaldados por la arqueología moderna.'];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-181">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-182">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-183" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 text-white leading-tight" data-id="element-184">
            De simples curiosidades... a comprender el verdadero legado del
            Antiguo Egipto
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-185">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark border border-dark-border p-8 rounded-2xl" data-id="element-186">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-187">
              Antes
            </h3>
            <ul className="space-y-4" data-id="element-188">
              {before.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-189">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-190" />
                  <span className="text-gray-300 text-lg" data-id="element-191">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark-lighter border border-gold/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-192">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16" data-id="element-193" />
            <h3 className="text-2xl font-bold text-gold-light mb-6 text-center" data-id="element-194">
              Con Egipto Legendario
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-195">
              {after.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-196">
                  <Check className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-197" />
                  <span className="text-white text-lg font-medium" data-id="element-198">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}